import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Card, Flex, Typography } from 'antd';

import dayjs from 'dayjs';

import messages from '../../../constants/messages';

import { setCurrentSelectedDay } from '../../../redux/actions/calendar';
import { fetchGeofences } from '../../../redux/actions/geofence';
import { fetchRotations } from '../../../redux/actions/geofence-rotations';

import { CALENDAR_VIEWS } from '../../../components/Calendar/constants';
import RotationTable from '../../../components/Grazing/RotationTable';
import PasturesCalendar from '../../../components/PasturesCalendar';
import { errorToastHandler } from '../../../components/action_notifier';

import AppBreadcrumb from '../../ui-components/AppBreadcrumb';

const { Title } = Typography;

function Grazing() {
  const dispatch = useDispatch();

  const { data: geofences, loading } = useSelector(state => state.geofence);
  const { loading: rotationsLoading } = useSelector(state => state.rotation);

  useEffect(() => {
    fetchData();

    return () => dispatch(setCurrentSelectedDay(dayjs().toISOString()));
  }, []);

  async function fetchData() {
    try {
      await Promise.all([dispatch(fetchGeofences()), getRotations()]);
    } catch (error) {
      errorToastHandler(error?.message || error?.response?.data?.message || messages.FAILED_ON_FETCH_DATA);
    }
  }

  async function getRotations(query = '') {
    try {
      await dispatch(fetchRotations({ query })).unwrap();
    } catch (error) {
      errorToastHandler(error?.message || error?.response?.data?.message || messages.FAILED_ON_FETCH_DATA);
    }
  }

  const resources = useMemo(
    () => geofences?.filter(g => !g.is_master)?.map(g => ({ id: g.id, title: g.name, eventColor: g.color })),
    [geofences]
  );

  return (
    <Card>
      <Flex vertical={true}>
        <Title level={4}>Grazing Planner</Title>
        <AppBreadcrumb items={[{ title: 'Plan grazing rotations and pasture utilisation' }]} />
      </Flex>

      <PasturesCalendar
        calendarHeight={300}
        initialView={CALENDAR_VIEWS.RESOURCE_WEEK}
        resources={resources}
        isLoading={loading || rotationsLoading}
        isToolbarVisible={false}
        slotLabelFormat={null}
      />

      <RotationTable geofences={geofences} fetchData={fetchData} handleSearchChange={getRotations} />
    </Card>
  );
}

export default Grazing;
